import React from "react";

const messageClass = {
  lead: "text-gray-300 italic",
  client: "text-gray-300 italic",
  employee: "text-white",
  bot: "text-white",
  calendar: "text-orange-300",
};

const HeroTimelineCard = ({ step, className = "" }) => (
  <div
    className={`backdrop-blur-md bg-white/5 border border-white/10 rounded-xl p-4 ${className}`}
    data-testid={`hero-timeline-card-${step.id}`}
  >
    <p className="font-mono text-sm font-bold text-white mb-1.5">{step.timestamp}</p>
    <p className="text-sm font-body leading-relaxed">
      <span className="mr-1" aria-hidden="true">
        {step.emoji}
      </span>
      <span className="text-white font-semibold">{step.label}</span>{" "}
      <span className={messageClass[step.role] || "text-gray-300"}>{step.message}</span>
    </p>
  </div>
);

export default HeroTimelineCard;
